module.exports = __webpack_public_path__ + "img/click_icon.366c0338.png";